export const TOPNAV_UPDATE='TOPNAV_UPDATE';


// WEBPACK FOOTER //
// ./src/redux/topnav/actionTypes.js